import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import Loader from "pages/Separate/Loader";
import NewPagination from "components/Common/Newpagination";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import { fetchData, fetchNodeData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import { customGlobalFilter } from "utils/common-helpers";
import Select from "react-select";
import { useSelector } from "react-redux";
import { colourStyles } from "utils/common-options";
import { leaveBalanceColumns } from "utils/columns/Human Resource/payrollColumns";

function TableContainer({
  columns,
  data,
  allData,
  setData,
  toggleLoading,
  members,
  setMembers,
  fetchData,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;
  const generalData = useSelector((state) => state?.GeneralData?.generalData);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    setPageSize(10);
  }, []);

  const handleFilter = () => {
    fetchData(members?.value || null);
  };

  // Access carryForwardEL from the first month (month: 1)
  const carryForwardEL =
    data?.find((item) => item.month === 1)?.carryForwardEL || 0;

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body">
            <div className="d-flex mb-2 align-items-start gap-3">
              <div className="mb-3 text-purple fs-5 fw-bold">Leave Report</div>
            </div>
            <Row className="mb-2 justify-content-between">
              <div className="mb-3 mb-md-0 d-flex justify-content-between align-items-center">
                <div className="col-3 d-flex align-items-center gap-3">
                  <select
                    className="border-radius form-select"
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                  <a className="d-flex gap-3 align-items-center general-box">
                    <h5 className="text-purple mb-0">
                      Balance (December {currentYear - 1}) : {carryForwardEL}
                    </h5>
                  </a>
                </div>

                <div className="col-8 d-flex justify-content-end align-items-center gap-4">
                  {localStorage.getItem("auth_id") == 1 ||
                  localStorage.getItem("auth_id") == 32 ||
                  localStorage.getItem("auth_id") == 4 ||
                  localStorage.getItem("auth_id") == 46 ? (
                    <div className="d-flex align-items-center gap-4 flex-nowrap">
                      <div style={{ minWidth: "400px", maxWidth: "900px" }}>
                        <Select
                          placeholder="Select Member"
                          className="basic-single-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={generalData?.staff}
                          value={members}
                          onChange={(selectedOption) =>
                            setMembers(selectedOption)
                          }
                          id="member-select"
                        />
                      </div>
                      <a
                        className="btn btn-sm me-1 bg-purple text-white"
                        style={{ borderRadius: "5px" }}
                        onClick={handleFilter}
                      >
                        <i className="bi bi-funnel-fill fs-5"></i>
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className="fixed_view_payment_table">
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1 header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody className="fix-table-body" {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row);
                    return (
                      <tr className="row-hover" {...row.getRowProps()} key={i}>
                        {row.cells.map((cell, index) => (
                          <td
                            key={index}
                            className={`t-col-${index + 1} ${
                              cell.column.className
                            }`}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const Leaves = () => {
  const [modal_Access, setAccessDenied] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [members, setMembers] = useState(null);
  const token = secureLocalStorage.getItem("auth_token");

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const getData = async (memberId = null) => {
    toggleLoading(true);
    const user_id = localStorage.getItem("auth_id");
    try {
      let res;
      if (!memberId) {
        res = await fetchNodeData(
          toggleLoading,
          `leaveBalance/${user_id}`,
          token
        );
      } else {
        res = await fetchNodeData(
          toggleLoading,
          `leaveBalance/${memberId}`,
          token
        );
      }
      if (res?.success) {
        console.log(res?.data);
        const responseData = Array.isArray(res?.data) ? res.data : [];
        setAllData(responseData);
        setData(responseData);
      } else {
        setAccessDenied(true);
        setAllData([]);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching leave balance:", error);
      setAccessDenied(true);
      setAllData([]);
      setData([]);
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const column1 = useMemo(() => leaveBalanceColumns(), []);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div>
        <Row>
          <Col lg="12">
            <Card>
              <div className="responsive-table">
                <TableContainer
                  columns={column1}
                  data={allData}
                  allData={allData}
                  setData={setData}
                  toggleLoading={toggleLoading}
                  members={members}
                  setMembers={setMembers}
                  fetchData={getData}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Leaves;
